import {
  SET_SELECTED_STATUS_ACTION,
  SET_SEARCH_TEXT_ACTION,
  SET_EMPRESA_ACTION,
  SET_CENTRO_CUSTO_ACTION,
  SET_PRODUTO_ACTION,
  SET_PROJETO_ACTION,
  SET_RESPONSAVEL_ACTION,
  SET_DATA_FINAL_ACTION,
  SET_DATA_INICIAL_ACTION,
  SET_URGENCIA_ACTION,
  SET_COMPRADOR_RESPONSAVEL_ACTION,
  SET_GRUPO_ACTION,
  SET_SITUACAO_ACTION,
  SET_LOCAL_ENTREGA_ACTION,
  SET_FILTER_ACTION,
  SET_LIST_OPTIONS_ACTION,
  RESET_PAGINATION,
  INIT_STATE_ACTION,
  SET_CURRENT_SESSION_STATE_ACTION,
} from './actions.type';

import {
  SET_SELECTED_STATUS,
  SET_SEARCH_TEXT,
  SET_EMPRESA,
  SET_CENTRO_CUSTO,
  SET_PRODUTO,
  SET_PROJETO,
  SET_RESPONSAVEL,
  SET_DATA_FINAL,
  SET_DATA_INICIAL,
  SET_URGENCIA,
  SET_COMPRADOR_RESPONSAVEL,
  SET_GRUPO,
  SET_SITUACAO,
  SET_LOCAL_ENTREGA,
  SET_CURRENT_PAGE,
  SET_OFFSET,
  SET_FILTER,
  SET_LIST_OPTIONS,
  INIT_STATE,
  SET_CURRENT_SESSION_STATE,
} from './mutations.type';

export default {
  [SET_SELECTED_STATUS_ACTION](context, status) {
    context.commit(SET_SELECTED_STATUS, status);
  },
  [SET_SEARCH_TEXT_ACTION](context, text) {
    context.commit(SET_SEARCH_TEXT, text);
  },
  [SET_EMPRESA_ACTION](context, empresa) {
    context.commit(SET_EMPRESA, empresa);
  },
  [SET_LOCAL_ENTREGA_ACTION](context, localEntrega) {
    context.commit(SET_LOCAL_ENTREGA, localEntrega);
  },
  [SET_CENTRO_CUSTO_ACTION](context, centroCusto) {
    context.commit(SET_CENTRO_CUSTO, centroCusto);
  },
  [SET_PRODUTO_ACTION](context, produto) {
    context.commit(SET_PRODUTO, produto);
  },
  [SET_PROJETO_ACTION](context, projeto) {
    context.commit(SET_PROJETO, projeto);
  },
  [SET_RESPONSAVEL_ACTION](context, responsavel) {
    context.commit(SET_RESPONSAVEL, responsavel);
  },
  [SET_DATA_FINAL_ACTION](context, dataFinal) {
    context.commit(SET_DATA_FINAL, dataFinal);
  },
  [SET_DATA_INICIAL_ACTION](context, dataInicial) {
    context.commit(SET_DATA_INICIAL, dataInicial);
  },
  [SET_URGENCIA_ACTION](context, urgencia) {
    context.commit(SET_URGENCIA, urgencia);
  },
  [SET_COMPRADOR_RESPONSAVEL_ACTION](context, compradorResponsavel) {
    context.commit(SET_COMPRADOR_RESPONSAVEL, compradorResponsavel);
  },
  [SET_GRUPO_ACTION](context, grupo) {
    context.commit(SET_GRUPO, grupo);
  },
  [SET_SITUACAO_ACTION](context, situacao) {
    context.commit(SET_SITUACAO, situacao);
  },
  [RESET_PAGINATION](context) {
    context.commit(SET_CURRENT_PAGE, 1);
    context.commit(SET_OFFSET, 0);
  },
  [SET_FILTER_ACTION](context, filter) {
    context.commit(SET_FILTER, filter);
  },
  [SET_LIST_OPTIONS_ACTION](context, listOptions) {
    context.commit(SET_LIST_OPTIONS, listOptions);
  },
  [INIT_STATE_ACTION](context, ids) {
    context.commit(INIT_STATE, ids);
  },
  [SET_CURRENT_SESSION_STATE_ACTION](context, ids) {
    context.commit(SET_CURRENT_SESSION_STATE, ids);
  },
};
